import { Entity } from '@toggle/toggle';
import { t } from 'i18next';
import React from 'react';

import { ErrorMessageWrapper } from '~/components/error-message-wrapper/ErrorMessageWrapper';

import { useEarningsStore } from '../../useEarningsStore/useEarningsStore';
import { getColumns } from '../../utils/tableUtils';
import { EarningsTable } from '../earnings-table/EarningsTable';

interface EarningsTableWrapperProps {
  isError: boolean;
  isRefetchError: boolean;
  entity: Entity;
  error: Error | null;
}

export const EarningsTableWrapper = ({
  isError,
  isRefetchError,
  entity,
  error,
}: EarningsTableWrapperProps) => {
  const {
    rowSelection,
    updateRowSelection,
    getIsAllRowsSelected,
    getIsSomeRowsSelected,
    toggleAllRowsSelection,
    getIsRowManualChanged,
    getIsRowMatchingFilters,
    earningsData,
  } = useEarningsStore();

  const columns = getColumns({
    getIsAllRowsSelected,
    getIsSomeRowsSelected,
    toggleAllRowsSelection,
    updateRowSelection,
    rowSelection,
    getIsRowManualChanged,
    getIsRowMatchingFilters,
    earningsData,
  });

  if (isError || isRefetchError) {
    throw new Error(error?.message);
  }

  if (!earningsData?.length) {
    return (
      <ErrorMessageWrapper
        variant="empty"
        displayIcon
        title={t('widget:earnings.empty.title')}
        subTitle={t('widget:earnings.empty.subTitle', { asset: entity.tag })}
      />
    );
  }

  return <EarningsTable columns={columns} entity={entity} />;
};
